"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isWorkType(object) {
    return checkWorkType(object).fulfilled;
}
exports.isWorkType = isWorkType;
function checkWorkType(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("name"), __1.hasBoolean("deleted"), __1.hasBoolean("editable"), __1.hasString("icon").optional()).withOptions(options).explain();
}
exports.checkWorkType = checkWorkType;
//# sourceMappingURL=WorkType.js.map